export const headerTokenUser = (token: string) => {
  return {
    headers: {
      'inweb3-token': token,
    },
  };
};
